import { Component, OnInit, OnDestroy, AfterViewInit, TemplateRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { StoreService } from '../../core';
import { HttpClient } from '@angular/common/http';
import { BaseStore, GenericData, RegistrationModel, RegistrationPortailModel, SessionItem, eItem, StagePrice, WSAppSource, WSRegMode, WSUserRole } from '../../shared';
import { Client, ConnectedUser, Contact, EndWithSlash } from 'projects/lib-components/src/public_api';

@Component({
  selector: 'webstore-extranet',
  templateUrl: './extranet.component.html',
  styleUrls: ['./extranet.component.css']
}) 

export class ExtranetComponent extends BaseStore implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('stagedetails', { static: false }) stagedtl: TemplateRef<any>;
  @ViewChild('cycledetails', { static: false }) cycledtl: TemplateRef<any>;
  @ViewChild('productdetails', { static: false }) productdtl: TemplateRef<any>;

  @ViewChild('contentRH', { static: false }) contentRH: TemplateRef<any>;
  @ViewChild('contentAPP', { static: false }) contentAPP: TemplateRef<any>;
  @ViewChild('contentAPPplus', { static: false }) contentAPPplus: TemplateRef<any>;

  @ViewChild('notfound', { static: false }) notfnd: TemplateRef<any>;

  private registrationData: RegistrationModel;
  private connectedUser: ConnectedUser | null = null;

  public templateContext: any = {};
  public pageTitle1: string;        // page title text
  public pageTitle2: string;        // page title text
  public listClient: Client[];
  public selctedClientId: string;
  public listContactsSelectedClient: GenericData<Contact>[];

  public pageExplications: string = '';
  public pageExplications2: string = '';
  public pageSendButton: string = '';
  public pageSendButton2: string = '';
  public showButtonInscription: boolean;   // Pour savoir si le bouton "Inscrire les contacts est obligatoire ou non"
  public filter: string;
  public returnPage: string;     // return page for back button

  listPrices: StagePrice[] = [];
  selectedPrice: string = '0';


  constructor(
    protected store: StoreService,
    private http: HttpClient,
    private cdr: ChangeDetectorRef
  ) { super(store); }

  ngOnInit(): void {
    this.connectedUser = this.store.AppParams.LoggedUser ? this.store.AppParams.LoggedUser : null;
    this.initData();
  }

  ngOnDestroy(): void {
    if (this.result)
      this.result.unsubscribe();
  }

  ngAfterViewInit(): void {
    // The method in the html setting the [ngTemplateOutlet] risks to run every single time change detection occurs.
    // And the first time the TemplateRef is set to undefined while in subsequent cycles the value gets updated.
    // --- in order to avoi this enconvenient, we added the ChangeDetectorRef class to execute change detection only after afterViewInit, when the dom is loaded ---
    this.cdr.detectChanges();
  }

  getContactByClient(): void {
    this.filter = '';
    this.showButtonInscription = true;

    if (this.selctedClientId === '0') {
      //////this.selectedClient = new Client();
      this.listContactsSelectedClient = [];
    }
    else {
      const clientSelected: Client[] = this.listClient.filter((c: Client): boolean => c.Ident === this.selctedClientId);
      if (clientSelected.length > 0) {
        //////this.selectedClient = clientSelected[0];
        //////this.listContactsSelectedClient = this.store.convertList<Contact>(this.selectedClient.ListContact, 3);
        this.listContactsSelectedClient = this.store.convertList<Contact>(clientSelected[0].ListContact, 3);
      }
    }

    if (this.listContactsSelectedClient.length === 0) {
      this.showButtonInscription = false;
      if (this.store.AppSettings.WebStoreUserRole !== WSUserRole.APPRENANT_PLUS) {
        this.pageExplications = this.store.AppSettings.WebStoreUserRole === WSUserRole.APPRENANT
          ? `Le client sélectionné n'a pas des responsables RH à qui notifier`
          : `Le client sélectionné n'a pas d'apprentis à inscrire`;
        this.store.warning(this.pageExplications);
      }
      return;
    }
  }

  filterContactList(): void {
    const clientSelected: Client[] = this.listClient.filter((c: Client): boolean => c.Ident === this.selctedClientId);
    if (clientSelected.length > 0) {
      if (this.filter === '')
        this.listContactsSelectedClient = this.store.convertList<Contact>(clientSelected[0].ListContact, 3);
      else {
        const fl: Contact[] = clientSelected[0].ListContact.filter((c: Contact): boolean => c.NomfaPER.toUpperCase().includes(this.filter.toUpperCase()) || c.Pre01PER.toUpperCase().includes(this.filter.toUpperCase()));
        this.listContactsSelectedClient = this.store.convertList<Contact>(fl, 3);
      }
    }
  }

  sendData(): void {
    const clientSelected: Client[] = this.listClient.filter((c: Client): boolean => c.Ident === this.selctedClientId);
    if (clientSelected.length === 0) {
      this.store.warning('Vous devez sélectionner un client');
      return;
    }

    const selectedContacts: Contact[] = clientSelected[0].ListContact.filter((c: Contact): boolean => c.IsSelected);
    if (selectedContacts.length === 0) {
      this.store.warning('Vous devez sélectionner au moins un contact');
      return;
    }

    this.registrationData.SelectedClient = clientSelected[0];
    this.registrationData.SenderRole = this.store.AppSettings.WebStoreUserRole;

    //#region MULTI-PRICE management (only for stages' preinscription)
    if (this.listPrices.length > 1) {
      if (this.selectedPrice === '0') {
        this.store.warning(`Vous devez choisir un prix`);
        return;
      }

      const sp: StagePrice[] = this.listPrices.filter((e: StagePrice): boolean => e.Order === this.selectedPrice);
      if (sp.length === 0) {
        this.store.showAlert(`un problème est survenu dans le choix d'un prix`);
        return;
      }
      this.registrationData.InscriptionData.Prix_Stage = sp[0];
    }
    //#endregion

    this.store.showSplash(true);
    if (this.store.AppSettings.WebStoreUserRole === WSUserRole.RH) {
      //#region the RH
      const destUrl: string = `${EndWithSlash(this.store.AppParams.apiUrl)}api/registration/V2/`;
      this.result = this.http.post<RegistrationModel>(destUrl, this.registrationData).subscribe((data: RegistrationModel): void => {
        this.store.showSplash(false);
        this.store.warning(data.Error !== '' ? data.Error : data.SuccessMessage);

        // TRACE ERROR (do not remove this line)
        if (data.HasError)
          this.store.traceData(`--FORMULAIRE ERROR: \r\n ${data.Error}`);
        // TRACE ERROR (do not remove this line)
        if (data.Alert && data.Alert !== '')
          this.store.traceData(`--FORMULAIRE ALERT: \r\n ${data.Alert}`);
      }, (error: any): void => { console.error(JSON.stringify(error)); });
      //#endregion
    }
    else {
      //#region the APPRENANT does not register any form, he just send a mail to the selected responsables RH and to himself (reminder)
      this.result = this.http.post<RegistrationModel>(`${EndWithSlash(this.store.AppParams.apiUrl)}api/registration/V2/apprenant`, this.registrationData).subscribe((data: RegistrationModel): void => {
        this.store.showSplash(false);
        this.store.warning(data.Error !== '' ? data.Error : data.SuccessMessage);

        // TRACE ERROR (do not remove this line)
        if (data.HasError)
          this.store.traceData(`--FORMULAIRE ERROR: \r\n ${data.Error}`);
        // TRACE ERROR (do not remove this line)
        if (data.Alert && data.Alert !== '')
          this.store.traceData(`--FORMULAIRE ALERT: \r\n ${data.Alert}`);
      }, (error: any): void => { console.error(JSON.stringify(error)); });
      //#endregion
    }
  }

  sendDataAppPlus(): void {
    const clientSelected: Client[] = this.listClient.filter((c: Client): boolean => c.Ident === this.selctedClientId);
    if (clientSelected.length === 0) {
      this.store.warning('Vous devez sélectionner un client');
      return;
    }

    //////const selectedContacts: Contact[] = clientSelected[0].ListContact.filter((c: Contact): boolean => c.IsSelected);
    //////if (selectedContacts.length === 0) {
    //////  this.store.warning('Vous devez sélectionner au moins un contact');
    //////  return;
    //////}

    this.registrationData.SelectedClient = clientSelected[0];
    this.registrationData.SenderRole = this.store.AppSettings.WebStoreUserRole;

    //#region MULTI-PRICE management (only for stages' preinscription)
    if (this.listPrices.length > 1) {
      if (this.selectedPrice === '0') {
        this.store.warning(`Vous devez choisir un prix`);
        return;
      }

      const sp: StagePrice[] = this.listPrices.filter((e: StagePrice): boolean => e.Order === this.selectedPrice);
      if (sp.length === 0) {
        this.store.showAlert(`un problème est survenu dans le choix d'un prix`);
        return;
      }
      this.registrationData.InscriptionData.Prix_Stage = sp[0];
    }
    //#endregion

    this.store.showSplash(true);

    const destUrl: string = `${EndWithSlash(this.store.AppParams.apiUrl)}api/registration/V2/`;
    this.result = this.http.post<RegistrationModel>(destUrl, this.registrationData).subscribe((data: RegistrationModel): void => {
      this.store.showSplash(false);
      this.store.warning(data.Error !== '' ? data.Error : data.SuccessMessage);

      // TRACE ERROR (do not remove this line)
      if (data.HasError)
        this.store.traceData(`--FORMULAIRE ERROR: \r\n ${data.Error}`);
      // TRACE ERROR (do not remove this line)
      if (data.Alert && data.Alert !== '')
        this.store.traceData(`--FORMULAIRE ALERT: \r\n ${data.Alert}`);
    }, (error: any): void => { console.error(JSON.stringify(error)); });

  }

  getTemplate(): TemplateRef<any> {
    let dtDisplay: string = '';
    switch (this.store.AppSettings.RegistrationMode) {
      case WSRegMode.PREINSCRIPTION_CYCLE:
        const cd: SessionItem | null = super.getSession(eItem.CYCLE);
        if (cd) {
          dtDisplay = cd.jsData;
          if (dtDisplay) {
            this.templateContext = JSON.parse(dtDisplay);
            return this.cycledtl;
          }
        }
        return this.notfnd;
      case WSRegMode.PREINSCRIPTION:
        const sd: SessionItem | null = super.getSession(eItem.STAGE);
        if (sd) {
          dtDisplay = sd.jsData;
          if (dtDisplay) {
            this.templateContext = JSON.parse(dtDisplay);
            return this.stagedtl;
          }
        }
        return this.notfnd;
      case WSRegMode.INFO:
        const pd: SessionItem | null = super.getSession(eItem.PRODUCT);
        if (pd) {
          dtDisplay = pd.jsData;
          if (dtDisplay) {
            this.templateContext = JSON.parse(dtDisplay);
            return this.productdtl;
          }
        }
        return this.notfnd;
      default:
        return this.notfnd;
    }
  }

  getTemplateBody(): TemplateRef<any> {
    switch (this.store.AppSettings.WebStoreUserRole) {
      case WSUserRole.RH:
        switch (this.registrationData.RegistrationMode) {
          case WSRegMode.INFO:
            this.pageExplications = `Sélectionnez les stagiaires à affecter à votre devis`;                 // this.store.getAlert('msgExtranet9')
            this.pageSendButton = `Envoyer ma demande`;                                                     // this.store.getAlert('msgExtranet10')
            break;
          case WSRegMode.PREINSCRIPTION:
            this.pageExplications = `Sélectionnez les stagiaires à affecter à la préinscription au stage`;  // this.store.getAlert('msgExtranet8')
            this.pageSendButton = `Préinscrire les contacts`;                                               // this.store.getAlert('msgExtranet11')
            break;
          case WSRegMode.PREINSCRIPTION_CYCLE:
            this.pageExplications = `Sélectionnez les stagiaires à affecter à la préinscription au cycle`;  // this.store.getAlert('msgExtranet7')
            this.pageSendButton = `Préinscrire les contacts`;                                               // this.store.getAlert('msgExtranet11')
            break;
        }
        return this.contentRH;
      case WSUserRole.APPRENANT:
        switch (this.registrationData.RegistrationMode) {
          case WSRegMode.INFO:
            this.pageExplications = `Selectionner le responsable RH a contacter par mail`;                  // this.store.getAlert('msgExtranet14');
            this.pageSendButton = `Envoyer mail`;                                                           // this.store.getAlert('msgExtranet15');
            break;
          case WSRegMode.PREINSCRIPTION:
            this.pageExplications = `Selectionner le responsable RH a contacter par mail`;                  // this.store.getAlert('msgExtranet14');
            this.pageSendButton = `Envoyer mail`;                                                           // this.store.getAlert('msgExtranet15');
            break;
          case WSRegMode.PREINSCRIPTION_CYCLE:
            this.pageExplications = `Selectionner le responsable RH a contacter par mail`;                  // this.store.getAlert('msgExtranet14');
            this.pageSendButton = `Envoyer mail`;                                                           // this.store.getAlert('msgExtranet15');
            break;
        }
        return this.contentAPP;
      case WSUserRole.APPRENANT_PLUS:
        switch (this.registrationData.RegistrationMode) {
          case WSRegMode.INFO:
            this.pageExplications = `Selectionner le responsable RH a contacter par mail`;                  // this.store.getAlert('msgExtranet14');
            this.pageSendButton = `Envoyer mail`;                                                           // this.store.getAlert('msgExtranet15');
            this.pageExplications2 = `Envoyer votre demande directement sans passer par votre RH`;
            this.pageSendButton2 = `Envoyer ma demande`;
            break;
          case WSRegMode.PREINSCRIPTION:
            this.pageExplications = `Selectionner le responsable RH a contacter par mail`;                  // this.store.getAlert('msgExtranet14');
            this.pageSendButton = `Envoyer mail`;                                                           // this.store.getAlert('msgExtranet15');
            this.pageExplications2 = `S'inscrire directement sans passer par votre RH`;
            this.pageSendButton2 = `Inscrivez-vous`;
            break;
          case WSRegMode.PREINSCRIPTION_CYCLE:
            this.pageExplications = `Selectionner le responsable RH a contacter par mail`;                  // this.store.getAlert('msgExtranet14');
            this.pageSendButton = `Envoyer mail`;                                                           // this.store.getAlert('msgExtranet15');
            this.pageExplications2 = `S'inscrire directement sans passer par votre RH`;
            this.pageSendButton2 = `Inscrivez-vous`;
            break;
        }
        return this.contentAPPplus;
      default:
        return this.notfnd;
    }
  }
  //#region data initialisation
  private initData(): void {
    this.registrationData = new RegistrationModel();
    this.registrationData.RegistrationMode = this.store.AppSettings.RegistrationMode;
    this.registrationData.Source = WSAppSource.EXTRANET;
    this.showButtonInscription = true;

    switch (this.registrationData.RegistrationMode) {
      case WSRegMode.PREINSCRIPTION_CYCLE:  // 'PREINSCRIPTIONCYCLE':
        this.initPreinscriptionCycles();
        this.returnPage = this.store.AppRoutes.CYCLEDETAILS;  // '/cursus/cyclefile';
        break;
      case WSRegMode.PREINSCRIPTION:        // 'PREINSCRIPTION'
        this.initPreinscription();
        this.returnPage = this.store.AppRoutes.STAGEDETAILS;  // '/stages/details';
        break;
      case WSRegMode.INFO:                  // 'INFO-FORM'
        this.initInfo();
        this.returnPage = this.store.AppRoutes.PRODUCTS;      // '/catalogsFormations/products';
        break;
    }
    this.store.showSplash(false);

    this.listClient = this.store.AppSettings.WebStoreUserRole === WSUserRole.RH
      ? this.store.AppSettings.ListApprenantsOrderedByClients
      : this.store.AppSettings.ListRHsOrderebByClients;

    if (this.listClient.length === 0) {
      this.showButtonInscription = false;
      this.pageExplications = `'Il n'y a pas des clients à sélectionner.Vous ne pouvez procéder à aucun enregistrement.`
      this.store.warning(this.pageExplications);
      return;
    }

    this.selctedClientId = this.listClient.length > 0 ? this.listClient[0].Ident : '0';
    this.listContactsSelectedClient = this.listClient.length > 0 ? this.store.convertList<Contact>(this.listClient[0].ListContact, 3) : [];

    if (this.listContactsSelectedClient.length === 0) {
      this.showButtonInscription = false;
      this.pageExplications = this.store.AppSettings.WebStoreUserRole === WSUserRole.APPRENANT
        ? `Le client sélectionné n'a pas des responsables RH à qui notifier`
        : `Le client sélectionné n'a pas d'apprentis à inscrire`;
      this.store.warning(this.pageExplications);
      return;
    }
  }

  private initPreinscriptionCycles(): void {
    this.pageTitle1 = `Préinscription au cycle`;// this.store.getAlert('msgExtranet1');
    this.registrationData.InscriptionCycleData.UserRole = this.store.AppSettings.WebStoreUserRole;
    if (this.connectedUser) {
      this.registrationData.InscriptionCycleData.ExtranetUser = this.connectedUser;
    }
    const d1: SessionItem | null = super.getSession(eItem.CYCLE);
    if (d1) {
      this.registrationData.CycleData = d1.jsData !== '' ? JSON.parse(d1.jsData) : undefined;
      if (this.registrationData.CycleData && this.registrationData.CycleData.ResponsableCycle) {
        this.pageTitle2 = this.registrationData.CycleData.ValueDOS;
        this.registrationData.InscriptionCycleData.ResponsablesList.push(this.registrationData.CycleData.ResponsableCycle);
      }
    }
  }

  private initPreinscription(): void {
    this.pageTitle1 = `Préinscription au stage`;  // this.store.getAlert('msgExtranet2');
    this.registrationData.InscriptionData.UserRole = this.store.AppSettings.WebStoreUserRole;
    if (this.connectedUser) {
      this.registrationData.InscriptionData.ExtranetUser = this.connectedUser;
    }
    const d2: SessionItem | null = super.getSession(eItem.STAGE);
    if (d2) {
      this.registrationData.StageData = d2.jsData !== '' ? JSON.parse(d2.jsData) : undefined;
      if (this.registrationData.StageData && this.registrationData.StageData.ResponsablesList) {
        this.pageTitle2 = this.registrationData.StageData.Info_PRO;

        //#region multi price management
        this.listPrices = this.registrationData.StageData.PricesList;
        if (this.listPrices.length === 1) {
          this.registrationData.InscriptionData.Prix_Stage = this.listPrices[0];
        }
        //#endregion

        this.registrationData.InscriptionData.ResponsablesList = this.registrationData.StageData.ResponsablesList;
      }
    }
  }

  private initInfo(): void {
    this.pageTitle1 = `Demande d'information`;  // this.store.getAlert('msgExtranet4');
    //////////////////this.pageExplications = this.store.AppSettings.WebStoreUserRole === WSUserRole.RH
    //////////////////  ? `Sélectionnez les stagiaires à affecter à votre devis`                // this.store.getAlert('msgExtranet9')
    //////////////////  : `Selectionner le responsable RH a contacter par mail`;                // this.store.getAlert('msgExtranet14');
    //////////////////this.pageSendButton = this.store.AppSettings.WebStoreUserRole === WSUserRole.RH
    //////////////////  ? `Envoyer ma demande`                                                  // this.store.getAlert('msgExtranet10')
    //////////////////  : `Envoyer mail`;                                                       // this.store.getAlert('msgExtranet15');
    this.registrationData.ProspectData.UserRole = this.store.AppSettings.WebStoreUserRole;
    if (this.connectedUser) {
      this.registrationData.ProspectData.ExtranetUser = this.connectedUser;
    }
    const d3: SessionItem | null = super.getSession(eItem.PRODUCT);
    if (d3) {
      this.registrationData.ProductData = d3.jsData !== '' ? JSON.parse(d3.jsData) : undefined;
      if (this.registrationData.ProductData && this.registrationData.ProductData.Responsable) {
        this.pageTitle2 = this.registrationData.ProductData.DesigPRO;
        this.registrationData.ProspectData.ResponsablesList.push(this.registrationData.ProductData.Responsable);
      }
    }
  }
  //#endregion
}
